module.exports = __webpack_public_path__ + "img/available_bal_icon.e44cafe8.svg";